// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/expand.js';

import { paths } from '../generated/expand';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('expand', Original, paths);
